// src/components/ui/Card.tsx
import React from 'react';

export default function Card({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded-2xl border border-border-primary bg-bg-secondary p-4">
      {children}
    </div>
  );
}
